import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

var state = {
	
}
var mutations = {
	
}
var actions = {
	
}
export default new Vuex.Store({
  state:state,
  mutations:mutations,
  actions : actions,
  strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js